import { ProtocolVisitForms } from '../models/Entities/Protocols/ProtocolVisitForms';
import { apiRequest } from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/protocols/';

/**
 * Formularios de las plantillas de visita vigentes del protocolo (EMR), sin paciente, ordenados por visita.
 * @param protocolId - Protocol ID
 * @param token - Authentication token
 */
export const GetProtocolVisitForms = async (protocolId: number, token: string): Promise<ProtocolVisitForms[]> => {
  const requestURL = `${BaseURL}${protocolId}/visits/forms`;
  return await apiRequest<ProtocolVisitForms[]>(requestURL, token, 'GetProtocolVisitForms');
};
